import 'core-js';
import 'regenerator-runtime';

/*
 * * * * * * * * * * * * * * *
 *
 *    Vue
 *
 * * * * * * * * * * * * * * *
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import VueObserveVisibility from 'vue-observe-visibility'

// ----

import App from './App.vue'
import {index} from "../../../core/env/browser/index";

// ----

for (const componentName in index.COMPONENT) {
    Vue.component(componentName, index.COMPONENT[componentName])
}

// ----

Vue.config.productionTip = false

// ----

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

// ----

Vue.use(VueRouter)
Vue.use(VueCookie)
Vue.use(VueObserveVisibility)

// ----

const vue = new Vue({
    router: new VueRouter({
        mode: 'history',
        routes: [
            {path: '/', component: index.COMPONENT.Home},
            {path: '/contact', component: index.COMPONENT.Contact},
            {path: '/formation', component: index.COMPONENT.Formation},
            {path: '/conseil/recrutement', component: index.COMPONENT.ConseilRecrutement},
            {path: '/conseil/externalisation', component: index.COMPONENT.ConseilExtern},
            {path: '/conseil/accompagnement', component: index.COMPONENT.ConseilAccomp},
            {path: '/evolution/accompagnement', component: index.COMPONENT.EvolutionAccomp},
            {path: '/evolution/bilan', component: index.COMPONENT.EvolutionBilan},
            {path: '/evolution/validation', component: index.COMPONENT.EvolutionValidation},
            {path: '/nous-connaitre/jobstream', component: index.COMPONENT.ConnaitreJobstream},
            {path: '/nous-connaitre/equipe', component: index.COMPONENT.ConnaitreEquipe},
            {path: '/nous-connaitre/nous-rejoindre', component: index.COMPONENT.ConnaitreRejoindre},
            {path: '/nous-connaitre/engagement-qualite', component: index.COMPONENT.ConnaitreEngagement},
            {path: '/nous-connaitre/confiance', component: index.COMPONENT.ConnaitreConfiance},
            {path: '/nous-connaitre/partenaires', component: index.COMPONENT.ConnaitrePartenaires},
            {path: '/politique-confidentialite', component: index.COMPONENT.Politique},
            {path: '/CGV', component: index.COMPONENT.CGV},
            {path: '/mentions-legales', component: index.COMPONENT.MentionsLegales},
            {path: '*', component: index.COMPONENT.Home},
        ]
    }),
    render: h => h(App)
})

// ----

index.main().then(() => {
    vue.$mount('#app')
}).catch(console.error)
